import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const getLoginPageSettings = async () => {
  try {
    let res = await Api.get("/login-page-settings");
    return res?.data || {};
  } catch (e) {
    return {};
  }
};

export const saveLoginPageSettings = async (data) => {
  try {
    let res = await Api.post("/login-page-settings", data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const createLoginPage = async (data) => {
  try {
    let res = await Api.post("/login-page-slider", data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getLoginPageData = async () => {
  try {
    let res = await Api.get("/login-page-slider", {
      // params: query,
      headers:{
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    });
  
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const getLoginPageDataById = async (id) => {
  try {
    let res = await Api.get("/login-page-slider/" + id);
  
    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const deleteLoginPageData = async (id) => {
  try {
    let res = await Api.delete("/login-page-slider/" + id);
  
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updateLoginPageData = async (id, data) => {
  try {
    let res = await Api.patch("/login-page-slider/" + id, data);
  
    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};
